module.exports = __webpack_public_path__ + "assets/media/evening.710bc3d2.mp3";